import React from 'react';

import styled from 'styled-components';
import Icon from '../../../../assets/images/lessonbuilder/trash.svg'

const StyledHandle = styled.div`
    width: 100%;
    height: 45px;
    align-self: flex-start;
    background-color: rgba(255,255,255, .2);
    display: flex;
    align-items: center;
    justify-content: center; 
    margin-bottom: 8px;
    align-self: flex-start;


    p {
        text-align: center;
        font: normal normal 22px 'Roboto Condensed';
        text-transform: uppercase;
        color: #fff;
    }

    img {
        height: 28px;
        margin-left: 32px;
    }
`

const Handle = (props) => {
    return(
        <StyledHandle>
            <p>{props.type}</p>
            <img src={Icon} onClick = {props.deleteAsset} />
        </StyledHandle>
    )
}

export default Handle;


// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/Handle/Handle.Component.jsx